import React from "react";
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Alert,
  Spinner,
} from "reactstrap";
import axios from "axios";
import { API_URL_costos } from "../../constants";
import 'react-datepicker/dist/react-datepicker.css';
import 'bootstrap/dist/css/bootstrap.min.css';



import { getAuthHeaders } from "../../utils/auth";
class NewCostoForm extends React.Component {

  state = {
    pk: 0,
    costo_code: "",
    costo: "",
    asignado_a: '',
    errorMessage: '',
    validationErrors: {},
    isSubmitting: false,
    dropdownOpen: false
  };

  componentDidMount() {
    if (this.props.costo) {
      const {
      pk,
      costo_code,
      costo,
      } = this.props.costo;
      this.setState({
        pk,
        costo_code,
        costo,
      });
    }
  }

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  toggleDropdown = () => {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  }

  validateForm = () => {
    const errors = {};
    const { costo } = this.state;

    if (!costo || costo.trim() === '') {
      errors.costo = 'Por favor ingresa el nombre del costo';
    }

    this.setState({ validationErrors: errors });
    return Object.keys(errors).length === 0;
  };

  createCosto = e => {
    e.preventDefault();

    if (!this.validateForm()) {
      this.setState({ errorMessage: 'Por favor completa todos los campos obligatorios marcados con *' });
      setTimeout(() => {
        const firstError = document.querySelector('.is-invalid');
        if (firstError) {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
          firstError.focus();
        }
      }, 100);
      return;
    }

    this.setState({ isSubmitting: true, errorMessage: '' });

    const headers = getAuthHeaders();
    axios.post(API_URL_costos, this.state, { headers }).then(() => {
      this.props.resetState();
      this.props.toggle();
    }).catch(error => {
      console.log(error);
      if (error.response?.data) {
        const serverErrors = error.response.data;
        if (typeof serverErrors === 'object' && !Array.isArray(serverErrors)) {
          this.setState({ validationErrors: serverErrors, isSubmitting: false });
        } else {
          this.setState({
            errorMessage: 'Error al crear el costo. Por favor verifica los datos.',
            isSubmitting: false
          });
        }
      } else {
        this.setState({
          errorMessage: 'Error de conexión. Por favor intenta nuevamente.',
          isSubmitting: false
        });
      }
    });
  };

  editCosto = e => {
    e.preventDefault();

    if (!this.validateForm()) {
      this.setState({ errorMessage: 'Por favor completa todos los campos obligatorios marcados con *' });
      setTimeout(() => {
        const firstError = document.querySelector('.is-invalid');
        if (firstError) {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
          firstError.focus();
        }
      }, 100);
      return;
    }

    this.setState({ isSubmitting: true, errorMessage: '' });

    const headers = getAuthHeaders();
    axios.put(API_URL_costos + this.state.pk, this.state, { headers }).then(() => {
      this.props.resetState();
      this.props.toggle();
    }).catch(error => {
      console.log(error);
      if (error.response?.data) {
        const serverErrors = error.response.data;
        if (typeof serverErrors === 'object' && !Array.isArray(serverErrors)) {
          this.setState({ validationErrors: serverErrors, isSubmitting: false });
        } else {
          this.setState({
            errorMessage: 'Error actualizando el costo. Por favor verifica los datos.',
            isSubmitting: false
          });
        }
      } else {
        this.setState({
          errorMessage: 'Error de conexión. Por favor intenta nuevamente.',
          isSubmitting: false
        });
      }
    });
  };

  defaultIfEmpty = value => {
    return value === "" ? "" : value;
  };


  render() {

    const {
      errorMessage,
      validationErrors,
      isSubmitting,
    } = this.state;


    return (
      <Form onSubmit={this.props.costo ? this.editCosto : this.createCosto}>
        <p style={{ fontSize: '0.9em', color: '#007bff', marginBottom: '1rem' }}>
          Los campos marcados con <span style={{ color: 'red' }}>*</span> son obligatorios
        </p>

        <FormGroup>
          <Label for="costo">Costo: <span style={{ color: 'red' }}>*</span></Label>
          <Input
            type="text"
            name="costo"
            onChange={this.onChange}
            value={this.defaultIfEmpty(this.state.costo)}
            invalid={!!validationErrors.costo}
          />
          {validationErrors.costo && (
            <div className="invalid-feedback d-block">{validationErrors.costo}</div>
          )}
        </FormGroup>

        {errorMessage && <Alert color="danger">{errorMessage}</Alert>}

        <Button color="primary" disabled={isSubmitting}>
          {isSubmitting ? (
            <>
              <Spinner size="sm" className="me-2" /> Guardando...
            </>
          ) : (
            this.props.costo ? "Actualizar Costo" : "Crear Costo"
          )}
        </Button>
      </Form>
    );
  }
}

export default NewCostoForm;
